import { render, staticRenderFns } from "./TaskListViewItem.vue?vue&type=template&id=09a3e940&scoped=true"
import script from "./TaskListViewItem.vue?vue&type=script&lang=ts"
export * from "./TaskListViewItem.vue?vue&type=script&lang=ts"
import style0 from "./TaskListViewItem.vue?vue&type=style&index=0&id=09a3e940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a3e940",
  null
  
)

export default component.exports